import io from 'socket.io-client'
import auth from './auth'

const socket = io(process.env.VUE_APP_API_URL, { query: `token=${auth.getToken()}`, path: '/socket' })

socket.on('connect', () => {
  console.log('Connected')
});

export const sendEvent = (eventName, data) => {
  const payload = {...data, userName: auth.getUser().USER_NAME}
  socket.emit(eventName, payload)
}
